import { useState } from "react";
import { ResultTitle } from "./ResultTitle";
import { SearchMiniReasult } from "./SearchMiniResult";
import { ICandidates, IItems } from "../types/types";
import { TСreateRequestHHDto } from "@src/entities/requestHH/api/requests/createRequestHH";
import { useRequesthResult } from "@src/shared/api/hooks/useRequestResult/useRequestResult";
import { WrapperLoading } from "@src/shared/components";

import styles from "./styles.module.scss";

interface ISearchResultContainer {
  item: IItems;
}

type CandidateScoreSource = {
  scores?: number | string | null;
  matching_score?: number | string | null;
  total_score_per_req?: {
    total_score?: number | string | null;
  } | null;
};

const normalizeScore = (score: number | string | null | undefined) => {
  if (score === null ||score === undefined || score === "") {
    return 0;
  }

  const parsedScore = Number(score);

  return Number.isFinite(parsedScore) ? parsedScore : 0;
};

const getCandidateScore = (candidate: CandidateScoreSource) => {
  return normalizeScore(
    candidate.total_score_per_req?.total_score ??
      candidate.matching_score ??
      candidate.scores,
  );
};

export const SearchResultContainer = ({ item }: ISearchResultContainer) => {
  const [isOpenList, setIsOpenList] = useState(false);

  const {
    isLoading: isLoadingRequestResult,
    getSearchRequestResult,
    searchRequestResult,
  } = useRequesthResult();

  const handleOpenListForResultTitle = () => {
    if (!isLoadingRequestResult && !searchRequestResult.length) {
      getSearchRequestResult(item.request_uuid);
    }

    setIsOpenList(true);
  };

  const handleOpenListForSearchMiniReasult = () => {
    if (!isLoadingRequestResult && !searchRequestResult.length) {
      getSearchRequestResult(item.request_uuid);
    }

    if (isOpenList) {
      const element = document.getElementById(`request-${item.request_uuid}`);

      if (element) {
        element.scrollIntoView({
          behavior: "instant",
          block: "start",
        });
      }
    }

    setIsOpenList((prev) => !prev);
  };

  const candidates = (
    isOpenList && searchRequestResult.length
      ? searchRequestResult.map((el) => ({
          ...el,
          relevant_experience_years: el.relevant_experience_duration,
          scores: getCandidateScore(el),
        }))
      : item.candidates.map((candidate) => ({
          ...candidate,
          scores: getCandidateScore(candidate),
        }))
  ) as ICandidates[];

  return (
    <WrapperLoading isLoading={isLoadingRequestResult}>
      <div
        key={`${item.request_uuid}`}
        className={styles.searchResultItem}
        id={`request-${item.request_uuid}`}
      >
        <ResultTitle
          params={item.params as unknown as TСreateRequestHHDto}
          title_vacancy={item.title_vacancy}
          status={item.status}
          handleOpenList={handleOpenListForResultTitle}
        />

        <SearchMiniReasult
          request_uuid={item.request_uuid}
          candidates={candidates}
          allCandidates={item.all_candidates}
          status={item.status}
          handleOpenList={handleOpenListForSearchMiniReasult}
          isShowAll={isOpenList}
        />
      </div>
    </WrapperLoading>
  );
};